@if (!permissionAllowed) {
  <div class="alert alert-danger">
    {{'i18n.shared.qr-scanner.errors.permissionDenied' | translate}}
  </div>
}
@if (!camerasFound) {
  <div class="alert alert-danger mt-2">
    {{'i18n.shared.qr-scanner.errors.no-camera-found' | translate}}
  </div>
}

@if (invalidQRError) {
  <div class="alert alert-danger mt-2">
    {{'i18n.shared.qr-scanner.errors.invalid-qr' | translate}}
  </div>
}

<div class="mt-2">
  @if (showCamera && activeCamera && camerasDropdownValues && camerasDropdownValues.length > 1) {
    <ejs-dropdownlist
                    id="controlPlate"
                    [fields]="dropdownSettings"
                    [value]="activeCamera.deviceId"
                    [dataSource]="camerasDropdownValues"
                    (valueChange)="setActiveCamera($event)"></ejs-dropdownlist>
  }
</div>

@if (cameraStarting) {
  <div class="d-flex align-items-center justify-content-center mt-2">
    <div class="spinner-border spinner-border me-3"
        role="status"></div>
  </div>
}

@if (showCamera) {
  <zxing-scanner
               class="mt-2"
               [formats]="allowedFormats"
               [tryHarder]="true"
               [ngClass]="{'no-height': cameraStarting}"
               [(device)]="activeCamera"
               (camerasFound)="onCamerasFound($event)"
               (scanError)="onError($event)"
               (scanComplete)="onScanComplete($event)"
               (autostarting)="onAutostarting($event)"
               (camerasNotFound)="onNoCameraFound($event)"
               (permissionResponse)="onPermissionResponse($event)"></zxing-scanner>
}

